"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getProductCode(clientShortHandName, isProduction) {
    if (isProduction === void 0) { isProduction = false; }
    if (!clientShortHandName) {
        return [''];
    }
    var prodProductIds = function (k) { return ({
        AP: ['301409', '301899', 'AP-EPAPER', 'AP-HIST', 'AP-BASIC'],
        ASK: ['301430', 'ASK-EPAPER'],
        BTI: ['301376', '301899', 'BT-EPAPER', 'BT-BASIC'],
        BYN: ['301436', 'BYN-BASIC'],
        DNB: [''],
        DP: ['301809', '301899', '301776'],
        MPL: [''],
        SA: ['301380', '301899', 'SA-EPAPER', 'SA-BASIC'],
        SCH: [''],
        STR: ['301434', 'STR-EPAPER'],
        VG: ['301899', '301899', 'FEA-VG-PLUSARTICLES', 'FEA-VG-SPORT', 'FEA-VG-EPAPER', 'FEA-VG-PRIVOK'],
        VNY: ['301435', 'VNY-EPAPER'],
    }[k]); };
    var testProductIds = function (k) { return ({
        AP: ['301439', '303129', 'AP-EPAPER', 'AP-HIST', 'AP-BASIC'],
        ASK: ['301564', 'ASK-EPAPER'],
        BTI: ['301367', '303129', 'BT-EPAPER', 'BT-BASIC'],
        BYN: ['301570', 'BYN-BASIC'],
        DNB: [''],
        DP: ['303030', '303129'],
        MPL: [''],
        SA: ['301712', '303129', 'SA-EPAPER', 'SA-BASIC'],
        SCH: [''],
        STR: ['301575', 'STR-EPAPER'],
        VG: ['301721', '303129', 'FEA-VG-PLUSARTICLES', 'FEA-VG-SPORT', 'FEA-VG-EPAPER', 'FEA-VG-PRIVOK'],
        VNY: ['301577', 'VNY-EPAPER'],
    }[k]); };
    return isProduction
        ? prodProductIds(clientShortHandName)
        : testProductIds(clientShortHandName);
}
exports.default = getProductCode;
//# sourceMappingURL=getProductCode.js.map